import { call, put, takeEvery, all, spawn } from 'redux-saga/effects';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';
import { fetchIncompleteJobsToContinue } from './graphql';

function* fetchIncompleteJobs(action: ReduxAction) {
  try {
    const { data } = yield call(fetchIncompleteJobsToContinue);

    yield put({
      type: actions.FETCH_INCOMPLETE_JOB_DONE,
      payload: data.incompleteJobsToContinue,
    });

  } catch (error) {
    yield put({
      type: actions.FETCH_INCOMPLETE_JOB_ERROR,
      payload: error,
    });
  }
}

function* watchFetchIncompleteJobs() {
  yield takeEvery(actions.FETCH_INCOMPLETE_JOB_START, fetchIncompleteJobs);
}

export default function* rootSaga() {
  yield all([
    spawn(watchFetchIncompleteJobs),
  ]);
}
